// Lib
import { createStructuredSelector } from 'reselect';

// Selectors
import { getUserContacts, getUserContactsMilanoteUsers } from '../../../../user/contacts/userContactsSelector';
import { getEmail } from '../../../../../common/users/userHelper';
import { createShallowSelector } from '../../../../utils/milanoteReselect/milanoteReselect';
import { getUserId } from '../../../../../common/users/utils/userPropertyUtils';
import filterUserSuggestions from './filterUserSuggestions';

const EMPTY_ARRAY = [];

const unconnectedContactsSelector = createShallowSelector(
    getUserContactsMilanoteUsers,
    getUserContacts,
    (contactMilanoteUsers, googleContacts) => {
        if (!googleContacts) return EMPTY_ARRAY;

        return googleContacts
            .filter(
                (contact) =>
                    getEmail(contact) && !contactMilanoteUsers.some((user) => getEmail(user) === getEmail(contact)),
            )
            .toArray();
    },
);

const notEditingUsersSelector = createShallowSelector(
    getUserContactsMilanoteUsers,
    (_, { filterUserIds }) => filterUserIds || [],
    (contactMilanoteUsers, filterUserIds) => {
        const currentEditorIdMap = filterUserIds.reduce((acc, userId) => {
            acc[userId] = true;
            return acc;
        }, {});

        return contactMilanoteUsers.filter((user) => !currentEditorIdMap[getUserId(user)]).toArray();
    },
);

const possibleSuggestionsSelector = createShallowSelector(
    notEditingUsersSelector,
    unconnectedContactsSelector,
    (notEditingUsers, unconnectedContacts) => [...notEditingUsers, ...unconnectedContacts],
);

const boardEditorSuggestions = createShallowSelector(
    possibleSuggestionsSelector,
    (state, props) => props.searchTerm,
    (possibleSuggestions, searchTerm) => filterUserSuggestions({ possibleSuggestions, searchTerm }),
);

export const boardEditorAddSectionSelector = createStructuredSelector({
    suggestedUsers: boardEditorSuggestions,
});
